import React, { Component } from 'react'
import foto from '../img/thaeron.jpg';

export default class Person extends Component {
    render() {
        return (
            <div className="w3-white w3-text-grey w3-card-4">
                <div className="w3-display-container">
                    <img src={foto} style={{width:'100%'}} alt="Avatar"/>
                    <div className="w3-display-bottomleft w3-container w3-text-white">
                        <h2>Thaeron Morales</h2>
                    </div>
                </div>
            </div>
        )
    }
}
